import React from "react";
import Form from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";
import RightArrowIcon from "../../icons/rightArrow";
import LeftArrowIcon from "../../icons/leftArrow";
import PasswordInput from "../../components/passwordInput";
import useMediaQuery from "../../hooks/useMediaQuery";
import LoadingButton from "../../components/loadingButton";
import ErrorMessage from "../../components/errorMessage";
import styles from "./style.module.css";
import formStyles from "../../components/form/style.module.css";

const schema = {
  type: "object",
  required: ["password", "confirmPassword"],
  properties: {
    password: {
      title: "Password",
      type: "string",
    },
    confirmPassword: {
      title: "Confirm Password",
      type: "string",
    },
  },
};

const uiSchema = {
  "ui:classNames": `${formStyles.formInner} ${styles.form_inner}`,
  "ui:rootFieldId": "forgot_step3",
  password: {
    "ui:widget": PasswordInput,
    "ui:classNames": `${formStyles.form_field} ${formStyles.col_12}`,
    "ui:placeholder": "••••••••",
  },
  confirmPassword: {
    "ui:widget": PasswordInput,
    "ui:classNames": `${formStyles.form_field} ${formStyles.col_12}`,
    "ui:placeholder": "••••••••",
  },
  "ui:submitButtonOptions": {
    props: {
      className: formStyles.form_btn,
    },
  },
};

const widgets = {
  password: PasswordInput,
  confirmPassword: PasswordInput,
};

function customValidate(formData, errors, uiSchema) {
  if (formData.password !== formData.confirmPassword) {
    errors.confirmPassword.addError("Passwords don't match");
  }
  return errors;
}

const Step3 = ({
  formData,
  onFormSubmit,
  onBackClick,
  loading,
  errorMessage,
}) => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  return (
    <div className={styles.form_outer}>
      {isMobile && (
        <div className={styles.form_back}>
          <div className={styles.form_back_btn} onClick={onBackClick}>
            <LeftArrowIcon />
          </div>
        </div>
      )}
      <div className={styles.form_title}>Set a New Password</div>
      <div className={styles.form_subtitle}>
        Create a new password. Ensure it differs from previous ones for security
      </div>
      <Form
        className={`${formStyles.form}`}
        schema={schema}
        uiSchema={uiSchema}
        widgets={widgets}
        formData={formData}
        validator={validator}
        customValidate={customValidate}
        showErrorList={false}
        omitExtraData={true}
        liveValidate={false}
        onSubmit={({ formData }) => {
          onFormSubmit(formData);
        }}
      >
        <div className={styles.form_btn_container}>
          <LoadingButton
            type="submit"
            loading={loading}
            title={"Update Password"}
            icon={<RightArrowIcon />}
          />
        </div>
      </Form>
      {errorMessage && <ErrorMessage message={errorMessage} mt />}
    </div>
  );
};

export default Step3;
